var _rect, _ellipse, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Desk lamp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#EEF2F8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 98,
    rx: 28,
    ry: 6,
    fill: "#002454",
    opacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 58,
    width: 8,
    height: 40,
    rx: 3,
    fill: "#002454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 58 C76 40 100 32 108 48",
    stroke: "#002454",
    strokeWidth: 5,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 44 L124 36 L118 58 Z",
    fill: "#9e00ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58 L108 52",
    stroke: "#9e00ff",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLamp);
export default __webpack_public_path__ + "static/media/product-lamp.e3c45b61ac3e97a81cc9bc3ff1408e19.svg";
export { ForwardRef as ReactComponent };